import { post, get, baseURL } from "@/utils/request";

// Get Channels list'
export const getChannels = (params: any) => post(`/paymentChannel/list`, params);

// Deposit
export const deposit = (params: any) => post(`/recharge`, params);

export const rechargeConfigurations = (data: any) => post(`/v1/rechargeConfiguration/values`, data);

export const getFirstRechargeRewardEligible = () => post(`/recharge/firstRechargeRewardEligible`);

export const callFirstRechargePopupNotShow = (type: any) => post(`/recharge/updateFirstRechargeRewardStatus/${type}`);

export const getErcCode = (params: any) => post(`/recharge/mark-check-flag?uid=${params.uid}&channelType=${params.channelType}`);